import(/* webpackMode: "eager", webpackExports: ["NewAppVersionDialog"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/app/_common/app-version/new-app-version-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryClientProvider"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/providers/query-client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WagmiProvider"] */ "/home/runner/work/dex-frontend/dex-frontend/apps/web/src/providers/wagmi-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BaseProviders"] */ "/home/runner/work/dex-frontend/dex-frontend/packages/ui/dist/base-providers.js");
